import React from "react";
import CustomDateRangePicker from "../../../CustomDatepicker/CustomDateRangePicker";
import CustominputRang from "../../../CustomInput/CustominputRang";
import { Grid } from "@mui/material";

import PropTypes from "prop-types";
import CustomSiteCodeInput from "../../../CustomSiteCode/customsitecodeinput";
import CustomARInput from "../../../CustomARInput/CustomARInput";
import CustomInput from "../../../CustomInput/CustomInput";
export default function ConditionAR(props) {
  const { defaultValue } = props;
  const [dateStart, setDatestart] = React.useState("");
  const [dateEnd, setDateend] = React.useState("");
  const [docNoStart, setDocnostart] = React.useState("");
  const [docNoEnd, setDocnoend] = React.useState("");
  const [siteCode, setSiteCode] = React.useState("");
  const [arCode, setArCode] = React.useState("");
  const [state, setState] = React.useState({
    chassisNumber: "",
    machineNumber: "",
  });
  React.useEffect(async () => {
    await props.result({
      dateStart:
        dateStart === ""
          ? typeof defaultValue["dateStart"] !== "undefined"
            ? defaultValue["dateStart"]
            : ""
          : dateStart,
      dateEnd:
        dateEnd === ""
          ? typeof defaultValue["dateEnd"] !== "undefined"
            ? defaultValue["dateEnd"]
            : ""
          : dateEnd,
      docNoStart:
        docNoStart === ""
          ? typeof defaultValue["docNoStart"] !== "undefined"
            ? defaultValue["docNoStart"]
            : ""
          : docNoStart,
      docNoEnd:
        docNoEnd === ""
          ? typeof defaultValue["docNoEnd"] !== "undefined"
            ? defaultValue["docNoEnd"]
            : ""
          : docNoEnd,
      siteCode:
        siteCode === ""
          ? typeof defaultValue["siteCode"] !== "undefined"
            ? defaultValue["siteCode"]
            : ""
          : siteCode,
      arCode:
        arCode === ""
          ? typeof defaultValue["arCode"] !== "undefined"
            ? defaultValue["arCode"]
            : ""
          : arCode,
      chassisNumber:
        state.chassisNumber === ""
          ? typeof defaultValue["chassisNumber"] !== "undefined"
            ? defaultValue["chassisNumber"]
            : ""
          : state.chassisNumber,
      machineNumber:
        state.machineNumber === ""
          ? typeof defaultValue["machineNumber"] !== "undefined"
            ? defaultValue["machineNumber"]
            : ""
          : state.machineNumber,
    });
    // await sessionStorage.setItem("resultConditionAP", JSON.stringify({ Datestart: Datestart, Dateend: Dateend, Docnostart: Docnostart, Docnoend: Docnoend, SiteCode: SiteCode, ARCode: ARCode }))
    return () => {};
  }, [
    dateStart,
    dateEnd,
    docNoStart,
    docNoEnd,
    siteCode,
    arCode,
    state.chassisNumber,
    state.machineNumber,
  ]);

  React.useEffect(() => {
    console.log("defaultValue  ConditionAR", defaultValue);
    //  setDatestart(defaultValue["Datestart"])
    //props.result(defaultValue)
    // await props.result({ Datestart: Datestart, Dateend: Dateend, Docnostart: Docnostart, Docnoend: Docnoend, SiteCode: SiteCode, ARCode: ARCode })
    return () => {};
  }, [defaultValue]);

  const resInput = (source, e) => {
    console.log("resInput", e);
    if (source === "DocNo") {
      setDocnostart(e.docNoStart);
      setDocnoend(e.docNoEnd);
    } else if (source === "SiteCode") {
      setSiteCode(e);
    } else if (source === "ARCode") {
      setArCode(e.arCode);
    } else if (source === "DocDate") {
      if (typeof e !== "undefined") {
        setDatestart(typeof e.dateStart !== "undefined" ? e.dateStart : "");
        setDateend(typeof e.dateEnd !== "undefined" ? e.dateEnd : "");
      }
    } else if (source === "ChassisNumber") {
      setState({
        ...state,
        chassisNumber: e,
      });
    } else if (source === "MachineNumber") {
      setState({
        ...state,
        machineNumber: e,
      });
    }
  };
  const keyDown = (e) => {
    console.log(e);
  };
  return (
    <Grid container spacing={3}>
      <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
        <CustomDateRangePicker
          label={"วันที่"}
          resData={(e) => resInput("DocDate", e)}
          defaultValue={defaultValue}
        />
      </Grid>
      <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
        <CustominputRang
          label={"เลขที่เอกสาร"}
          resData={(e) => resInput("DocNo", e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
          defaultValue={defaultValue}
        />
      </Grid>
      <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
        <CustomSiteCodeInput
          label={"สาขา"}
          resData={(e) => resInput("SiteCode", e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
          defaultValue={defaultValue["siteCode"]}
        />
      </Grid>
      <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
        <CustomARInput
          label={"ลูกค้า"}
          resData={(e) => resInput("ARCode", e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
          defaultValue={defaultValue["arCode"]}
        />
      </Grid>

      <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
        <CustomInput
          label={"เลขตัวถัง"}
          resData={(e) => resInput("ChassisNumber", e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
          defaultValue={defaultValue["chassisNumber"]}
        />
      </Grid>

      <Grid2 xs={6} sm={12} md={6} lg={4} xl={4}>
        <CustomInput
          label={"เลขเครื่อง"}
          resData={(e) => resInput("MachineNumber", e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
          defaultValue={defaultValue["machineNumber"]}
        />
      </Grid2>
    </Grid>
  );
}

ConditionAR.propTypes = {
  defaultValue: PropTypes.array.isRequired,
};
